if (!customElements.get('product-add-to-cart-sticky')) {
    class ProductAddToCartSticky extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.section;
        this.variantChangeUnsubscriber = undefined;
        this.isTargetOutOfView = false;
        this.isFooterInView = false;
      }
  
      connectedCallback() {
        this.targetElement = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.footerElement = document.querySelector('footer');
        this.stickyAtcVariantInput = this.querySelector('.product-variant-id');
        
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange.bind(this)
        );
  
        if (!this.targetElement) return;

        this.targetObserver = new IntersectionObserver(([entry]) => {
          this.isTargetOutOfView = !entry.isIntersecting;
          this.toggleVisibility();
        }, { rootMargin: '0px 0px 10000% 0px' });
        this.targetObserver.observe(this.targetElement);

        if (!this.footerElement) return;

        this.footerObserver = new IntersectionObserver(([entry]) => {
          this.isFooterInView = entry.isIntersecting;
          this.toggleVisibility();
        }, { rootMargin: '10000% 0px 0px 0px' });
        this.footerObserver.observe(this.footerElement);
      }
  
      disconnectedCallback() {
        this.targetObserver?.disconnect();
        this.footerObserver?.disconnect();
        
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }
  
      toggleVisibility() {
        this.classList.toggle('show', this.isTargetOutOfView && !this.isFooterInView);
      }
  
      handleVariantChange({ data: { sectionId, html, variant } }) {
        const mainSectionId = this.sectionId.replace(/^template--\d+__/, '');
        const eventSectionId = sectionId.replace(/^template--\d+__/, '');
        
        if (mainSectionId !== eventSectionId) return;
  
        // Update variant input
        if (this.stickyAtcVariantInput) {
          this.stickyAtcVariantInput.value = variant?.id || '';
          this.stickyAtcVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
  
        this.updateStickyOptionsFromHTML(sectionId, html);
      }
  
      updateStickyOptionsFromHTML(sectionId, html) {
        const sourceOptionsContainer = html.querySelector('.selected-variant-details .options-container');
        const destinationOptionsContainer = this.querySelector('.selected-variant-details .options-container');
  
        if (!sourceOptionsContainer || !destinationOptionsContainer) return;
  
        const sourceOptions = sourceOptionsContainer.querySelectorAll('.selected-variant-option');
        const destinationOptions = destinationOptionsContainer.querySelectorAll('.selected-variant-option');
  
        sourceOptions.forEach((sourceOption, index) => {
          if (destinationOptions[index]) {
            destinationOptions[index].textContent = sourceOption.textContent;
          }
        });
      }
    }
  
    customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
  }
  